import styled from "styled-components";

export const Label = styled.label`
  background: transparent;
  box-sizing: border-box;
  color: inherit;
  display: inline-flex;
  font-size: 0.9rem;
  margin: 0;
  padding: 0;
`;
